import { render, staticRenderFns } from "./MoveShot.vue?vue&type=template&id=6e92a33a&scoped=true&"
import script from "./MoveShot.vue?vue&type=script&lang=js&"
export * from "./MoveShot.vue?vue&type=script&lang=js&"
import style0 from "./MoveShot.vue?vue&type=style&index=0&id=6e92a33a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e92a33a",
  null
  
)

export default component.exports